/* eslint-disable */
export default {
  _background: 'background',
  _background_with_rays: 'background_with_rays',
  _sand: 'sand',
  _ray5: 'ray5',
  _ray3: 'ray3',
  _bonus_round: 'bonus_round',
  _ray4: 'ray4',
  _round_dial: 'round_dial',
  _title_photo: 'title_photo',
  _pop_bubbles_label: 'pop_bubbles_label',
  _ray2: 'ray2',
  _ray1: 'ray1',
  _next_round_button: 'next_round_button',
  _play_again_button: 'play_again_button',
  _try_again_button: 'try_again_button',
  _bubble: 'bubble',
  _time_dial: 'time_dial',
  _letter_names_button: 'letter_names_button',
  _letter_sounds_button: 'letter_sounds_button',
  _go_button: 'go_button',
  _number_box: 'number_box',
  _tiny_bubble: 'tiny_bubble',
  _orange_dot: 'orange_dot',
  _bubble_fragment: 'bubble_fragment',
  _green_dot_selected: 'green_dot_selected',
  _green_dot: 'green_dot',
  _intro_background: 'intro_background',
  _ray6: 'ray6',
}